<template>
  <common-dialog ref="dialog" :title="title" width="650px" :in-dialog="inDialog">
    <list
      row-key="UserId"
      ref="list"
      unit="记录"
      :expand-all-row="true"
      :page="false"
      :query-params="params"
      :show-checkbox="false"
      :show-query="false"
      :show-toolbar="false"
      :get-data-func="api.getIndexLeaveDts"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <el-table-column prop="ClassName" label="班级" />
        <el-table-column prop="FullName" label="姓名"  />
        <el-table-column prop="LeaveType" label="请假类型"  />
        <slot name="column"></slot>
      </template>
    </list>
  </common-dialog>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import commonDialog from "@/components/common/dialog";
import listDialogMixins from "@/mixins/listDialog";
export default {
  mixins: [listMixin,listDialogMixins],
  components: { list,commonDialog },
  props: {
    
  },
  data() {
    return {
      api: require("@/api/at/attendance").default,
      title: "请假明细",
      params: {
        
      },
    };
  },
  methods: {
    
  },
};
</script>